import type { SerializedCreditInvoice } from '@enmon/commons/lib/enmon';
import type { ColumnsType } from 'antd/lib/table';
import type { PopulatedSerializedCreditInvoice } from 'lib/services';
import dayjs from 'dayjs';
import { ActionTableButtons } from '../components/ActionTableButtons';

export const getColumns = (
  onEdit: (creditInvoice: PopulatedSerializedCreditInvoice) => void,
  onDelete: (id: SerializedCreditInvoice['_id']) => void,
): ColumnsType<PopulatedSerializedCreditInvoice> => [
  {
    title: 'Reseller',
    key: 'reseller',
    dataIndex: ['reseller', 'name'],
    width: 300,
  },
  {
    title: 'Customer',
    key: 'customer',
    dataIndex: ['customer', 'name'],
    width: 300,
  },
  {
    title: 'Invoice number',
    key: 'invoice_number',
    dataIndex: ['invoiceNumber'],
    width: 150,
  },
  {
    title: 'Date',
    key: 'date',
    render: (_, { date }) => dayjs(date).format('YYYY-MM-DD') ?? '',
    width: 100,
  },
  {
    title: 'Implementation',
    key: 'implementation',
    dataIndex: ['implementation'],
    width: 100,
    render: (_, { implementation: { meterOffline, meterOnline, establishment, customer } }) =>
      meterOffline && meterOnline && establishment
        ? `${customer?.count} / ${establishment?.count} / ${meterOnline?.count} / ${meterOffline?.count}`
        : '',
  },
  {
    title: 'Credit establishment',
    key: 'credit_establishment',
    dataIndex: ['credit', 'establishment', 'count'],
    width: 200,
  },
  {
    title: 'Credit meter online',
    key: 'credit_meter_online',
    dataIndex: ['credit', 'meterOnline', 'count'],
    width: 200,
  },
  {
    title: 'Credit meter offline',
    key: 'credit_meter_offline',
    dataIndex: ['credit', 'meterOffline', 'count'],
    width: 200,
  },
  {
    title: 'Actions',
    width: 50,
    render: (_value, creditInvoice) => (
      <ActionTableButtons
        hasSnapshot={Boolean(creditInvoice.snapshot)}
        onDelete={() => onDelete(creditInvoice._id)}
        onEdit={() => onEdit(creditInvoice)}
      />
    ),
  },
];
